import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CustomerDto,
  CustomerListDto,
  CustomerFilterDto,
  CreateCustomerRequest,
  UpdateCustomerRequest,
  CustomerStatementDto,
} from '@/types/customer.types';

export const customerApi = {
  /** GET /api/v1/customers — paginated list with optional search/filter */
  getList: (filter?: CustomerFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CustomerListDto>>>('/customers', {
      params: filter,
    }),

  /** GET /api/v1/customers/{id} — full customer record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CustomerDto>>(`/customers/${id}`),

  /** GET /api/v1/customers/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<CustomerDto>>(
      `/customers/by-code/${encodeURIComponent(code)}`,
    ),

  /** POST /api/v1/customers — create a new customer */
  create: (data: CreateCustomerRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/customers', data),

  /** PUT /api/v1/customers/{id} — update customer details */
  update: (id: string, data: UpdateCustomerRequest) =>
    apiClient.put<ApiResponse<object>>(`/customers/${id}`, data),

  /** DELETE /api/v1/customers/{id} — soft-delete the customer */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/customers/${id}`),

  /** GET /api/v1/customers/{id}/statement — chronological statement with running balance */
  getStatement: (
    id: string,
    params: { dateFrom?: string; dateTo?: string; currencyCode?: string },
  ) =>
    apiClient.get<ApiResponse<CustomerStatementDto>>(
      `/customers/${id}/statement`,
      { params },
    ),
};
